import Typography from "@mui/material/Typography";
import type { JSX } from "react";

interface SummaryValueProps {
  label: string;
  value: string;
}

/**
 * Строка сводки «подпись: значение» с выделенным значением. Живёт в
 * дизайн-системе, чтобы сводки на всех экранах выглядели одинаково.
 */
export function SummaryValue(props: SummaryValueProps): JSX.Element {
  return (
    <Typography variant="body2">
      {props.label}: <strong>{props.value}</strong>
    </Typography>
  );
}
